import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";

const PRItem = (props) => {
  const { exerciseName, value, delta, units = "kgs" } = props;
  // A record with nothing earlier to compare against carries no delta. Rendering
  // the block anyway would fail the `delta >= 0` test and show a red down-arrow
  // beside an empty number.
  const hasDelta = delta != null;
  return (
    <div>
      <div className="pr-item">
        <div>{exerciseName}</div>
        <div>
          {value} <span className="units">{units}</span>
        </div>
        {hasDelta && (
          <div className="pr-delta">
            <SvgIcon
              noFilterOnLight={true}
              src={
                delta >= 0
                  ? "/img/new-icons/arrow-up-blue.svg"
                  : "/img/new-icons/red-arrow-down.svg"
              }
            />
            <div className="delta">{delta}</div>
            <div className="units">{units}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PRItem;
